export enum AUTH0_ROLE {
  NONE = '',
  PROSPECT = 'Prospect',
  CLIENT = 'Client',
  BUSINESS = 'Business',
  ADMIN = 'Admin',
  SIGNUP = 'Signup',
  TRIAL = 'Trial',
  EXPIRED = 'Expired'
}

/** Account-level subscription (effective — the server derives EXPIRED when the trial end has passed). */
export type SubscriptionStatus = 'NONE' | 'TRIALING' | 'ACTIVE' | 'EXPIRED';

export interface UserProfile {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  role: AUTH0_ROLE;
  account?: string;
  trialDaysLeft: number | null;
  companyName?: string;
  subscriptionStatus?: SubscriptionStatus;
  trialEndsAt?: string;
}

export interface UserProfileResponse {
  id: string;
  email: string;
  firstName: string;
  lastName: string;
  lastLogin: string;
  createdAt: string;
  role: AUTH0_ROLE;
  brands: { key: string; name: string }[];
  organizations: { key: string }[];
  account?: { key: string; name: string };
  verifiedEmail?: boolean;
  companyName?: string;
  jobTitle?: string;
  trialDaysLeft?: number;
  isNewUser?: boolean;
  subscriptionStatus?: SubscriptionStatus;
  trialEndsAt?: string;
}